import SEO from '../components/SEO';
import MarketingSection from '../features/generator/components/MarketingSection';

export default function AboutPage() {
    return (
        <main className="flex-1 app-scroll">
            <SEO
                title="About AuraIcon - App Store Icon Generator"
                description="Learn more about AuraIcon, the professional AI icon generator for iOS and Android. High-quality, scalable, and App Store ready icons."
                canonical="/about"
            />
            <div className="container-page py-12">
                <div className="max-w-4xl mx-auto">
                    <header className="mb-16 text-center">
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                            About AuraIcon
                        </h1>
                        <p className="text-xl text-slate-400">
                            Empowering developers and designers with high-quality, App Store ready icons powered by AI.
                        </p>
                    </header>

                    <MarketingSection />
                </div>
            </div>
        </main>
    );
}
